import React, { useEffect, useState } from "react";
import "./style.css";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useParams } from "react-router-dom"; // To get product ID from URL
import { baseURL } from "../../constants/url";

function ProductsListDescription() {
  const { id } = useParams(); // Make sure your route is like /product/:id
  const [product, setProduct] = useState(null);

  useEffect(() => {
    fetch(`${baseURL}common/products/${id}/`)
      .then((res) => res.json())
      .then((data) => {
        setProduct(data);
      })
      .catch((err) => {
        console.error("Error fetching product:", err);
      });
  }, [id]);

  if (!product) return <p className="common_text">Loading description...</p>;

  return (
    <div className="products_description_box">
      <div className="products_description_box_in">
        <h5 className="common_color">Description</h5>
        <p className="common_text">
          {product.description || "No description available for this product."}
        </p>
        <table className="no_border_old border_tr widthHalf mt_20 tbl_corcle">
          <tbody>
              <tr>
              <td><FiberManualRecordIcon className="circle_deco" /></td>
              <td>Quantity Per Case</td>
              <td>{product.weight || "N/A"} {product.unit}</td>
            </tr>
            <tr>
              <td><FiberManualRecordIcon className="circle_deco" /></td>
              <td>Length</td>
              <td>{product.length} cm</td>
            </tr>
            <tr>
              <td><FiberManualRecordIcon className="circle_deco" /></td>
              <td>Width</td>
              <td>{product.width} cm</td>
            </tr>
            <tr>
              <td><FiberManualRecordIcon className="circle_deco" /></td>
              <td>Height</td>
              <td>{product.height} cm</td>
            </tr>
          </tbody>
        </table>

        <div className="mt_20">
          <h5 className="common_color border_bottom pb_5 mt_15">Packaging & Delivery</h5>
          <p className="common_text">
            Products are carefully packed, Delivery timelines may vary depending on the location.
          </p>
        </div>
      </div>
    </div>
  );
}

export default ProductsListDescription;
